module.exports = __webpack_public_path__ + "static/media/btn-birthday.54da45c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/birthday/components/images/btn-birthday.png
// module id = 989
// module chunks = 0